// Move 'All bookmarks' from the end of the array to the front
const reorderBookmarkCategoryAnchors = () => {
	const list = document.querySelector('.cbxbookmark-category-list');
	if (!list) return;
	const lastChild = list.querySelector('li:last-child');
	if (lastChild) {
		list.insertBefore(lastChild, list.firstElementChild);
	}
};

const highlightActiveBookmarkCategory = (documentLocation) => {
	const query = documentLocation.getUrlParameterByName('cbxbmcatid');

	// if we're filtering by category, highlight category
	if (query) {
		const pattern = new RegExp('cbxbmcatid=' + query + '$');
		document.querySelectorAll('.cbxbookmark-category-list li a').forEach(anchor => {
			if (pattern.test(anchor.href)) {
				anchor.parentElement.classList.add('active');
			}
		});
	} else {
		// highlight 'All'
		const first = document.querySelector('.cbxbookmark-category-list li:first-of-type');
		if (first) first.classList.add('active');
	}
};

const showBookmarks = () => {
	const el = document.querySelector('.account__bookmarks');
	if (el) el.style.visibility = 'inherit';
};


const init = (documentLocation) => {
	// if we're on the account page, reorder and highlight bookmark categories
	const accountPageRegex = /^\/account(\/[^\/]*)?$/;
	if (accountPageRegex.test(window.location.pathname)) {
		reorderBookmarkCategoryAnchors();
		highlightActiveBookmarkCategory(documentLocation);
		showBookmarks();
	}
};

export default {
	init
};